define('commons/csv-export',['jquery', 'commons/popup-dialog', 'commons/message-manager', 'jquery.ui'], function($, PopupDialog, messages) {
    return function(exportContainer, options) {
        this.settings = {
            popupTitle: "Export entity",
            popupLinks: ".csv-export-link",
            exportBaseUrl: "",
            exportUrl: "csv/global-export.csv",
            urlAbsolute : false,
            form: "",
            additionalParams: {},
            onBeforeOpen: function() {
                return true;
            },
            classes: "csv-export-dialog"
        };
        $.extend(this.settings, options);

        // Create popup
        this.popupExport = new PopupDialog(exportContainer, {
            classes: this.settings.classes,
            popupTitle: this.settings.popupTitle,
            popupLinks: this.settings.popupLinks,
            onBeforeOpen: this.settings.onBeforeOpen,
            onSuccess: function(data) {
             // display as menu (explorer like)
                $(".fields").menu({ position: { my: "left top", at: "right top", of: ".fields"}});
                // propagate embedded selected to all sub element
                $('a[data-embedded="true"]').click(function(event) {
                    var subs = $(event.target.parentElement).find(".sub-menu");
                    var hasClass = $(event.target).hasClass("selected");
                    for(var i = 0; i < subs.length; i++) {
                        if (hasClass) {
                            $(subs[i]).removeClass("selected");
                        } else {
                            $(subs[i]).addClass("selected");
                        }
                    }
                });
                $(".field-menu").click(function( event ) {
                    event.stopPropagation();
                    $(event.target).toggleClass('selected');
                    $(event.target).removeClass('partial');
                });
                $(".sub-menu").click(function( event ) {
                    event.stopPropagation();
                    var elem = $(event.target);
                    elem.toggleClass('selected');
                    var supUl = elem.parents(".sub");
                    var parent = supUl.siblings(".field-menu");
                    var subs = supUl.find(".sub-menu");
                    var nbSelected = 0;
                    for(var i = 0; i < subs.length; i++) {
                        if ($(subs[i]).hasClass("selected")) {
                            nbSelected++;
                        }
                    }
                    // change parent state if all or none subs are selected
                    if (nbSelected === 0) {
                        parent.removeClass('partial');
                        parent.removeClass("selected");
                    } else if (nbSelected == subs.length) {
                        parent.addClass('selected');
                        parent.removeClass('partial');
                    } else {
                        parent.removeClass("selected");
                        parent.addClass("partial");
                    }
                });
                $(".fields" ).sortable();
                $(".sub" ).sortable();
            },
            width: 500,
            height: 390,
            buttons: [{
                text: "Export",
                click: $.proxy(function() {
                    var popup = this.popupExport.popup;
                    // retrieving all selected fields
                    var data = [];
                    popup.find(".fields a.selected").each(function() {
                        var $this = $(this);
                        // do not add embedded field but sub-field
                        if (!$this.data("embedded")) {
                            var id = $this.data('value');
                            data.push(id);
                        }
                    });
                    var asynchronous = $("input[name=asynchronous]:checked").val() == "true";
                    // start construct url
                    var url = [];
                    // adress
                    if (this.settings.urlAbsolute) {
                        url.push(location.origin, "/");
                    }
                    if (this.settings.exportBaseUrl) {
                        url.push(this.settings.exportBaseUrl, '/', this.settings.exportUrl);
                    } else {
                        url.push(this.settings.exportUrl);
                    }
                    // list of selected fields
                    url.push('?', $.param({
                        fields: data
                    }, true));
                    // mode for export
                    if (asynchronous) {
                        url.push('&asynchronous=true');
                    }
                    // form filter parameters
                    if (this.settings.form) {
                        var form = $(this.settings.form);
                        url.push('&', form.serialize());
                        if (form[0].fullPage) {
                            url.push('&' + form[0].fullPage.value);
                        }
                    }
                    // Other specific parameters
                    if (this.settings.additionalParams) {
                        url.push('&', $.param(this.settings.additionalParams, true));
                    }
                    // execute request
                    if (asynchronous) {
                        $.ajax({
                            type: 'GET',
                            url: url.join(""),
                            success: function(result) {
                                messages.info("An email will be sent to you when results are available");
                            }
                        });
                    } else {
                        location.href = url.join("");
                    }
                    popup.dialog("close");
                }, this)
            }, {
                text: "Cancel",
                click: function() {
                    $(this).dialog("close");
                }
            }]
        });
        
        var that = this;
        
        this.popupExport.loadDataPopup = function(url) {
        	// form filter parameters
            if (that.settings.form) {
            	if (url.indexOf('?') >= 0) {
            		url += '&';
            	} else {
            		url += '?';
            	}
            	
                var form = $(that.settings.form);
                url += form.serialize();
                if (form[0].fullPage) {
                    url += '&' + form[0].fullPage.value;
                }
            }
            
        	return PopupDialog.prototype.loadDataPopup.call(this, url);
        };
    };
});

